<template lang="pug">
	.audio-track-info.track(:class="[track.__isAudioTrack ? 'audio' : '', !!track.breakType ? 'break' : '']")
		.track-info-holder.flex-col(:ref="`trackInfo_${track.id}`")
			.track-actions.flex-row.justify.space(v-if="compact && track.__isSubTrack")
				.left-actions.flex-row.space.wrap.align-center
					.button.flex-row.center.align-center(:title="$tCaption('Solo')", :class="{ 'is-solo': isSolo }", @click="v => $emit('solo', aggregatedTrack)") S
					.button.flex-row.center.align-center(:title="$tCaption('Mute')", :class="{ 'is-muted': isMuted }", @click="$emit('mute', aggregatedTrack)") M
				.right-actions.flex-row.space.wrap.align-center
					slot(name="track-compact-right-actions", :aggregatedTrack="aggregatedTrack", :track="track", :trackName="trackName")
					.button.flex-row.center.align-center(:title="$tCaption('Delete track')", @click="onTrackDelete")
						fas(icon="trash")
					.button.no-space.flex-row.center.align-center.compact-icon(:title="compact ? $tCaption('Expand') : $tCaption('Collapse')", @click="toggleCompact", :class="[!compact ? 'rotated' : '']")
						fas(icon="chevron-down")
			.track-info.flex-row.justify.name-field-holder(v-if="compact && !track.__isSubTrack", :style="{ '--color': aggregatedTrack.color || '#e0e0e0' }")
				.flex-1
					.name-field.full-height(v-if="$scopedSlots['track-name']")
						slot(name="track-name", :aggregatedTrack="aggregatedTrack", :track="track", :trackName="trackName")
					.name-field.full-height(v-else, :title="aggregatedTrack.name") {{aggregatedTrack.name}}
				.track-actions.flex-row.align-center
					.flex-row.space.wrap
						.button.no-space.flex-row.center.align-center.compact-icon(:title="compact ? $tCaption('Expand') : $tCaption('Collapse')", @click="toggleCompact", :class="[!compact ? 'rotated' : '']")
							fas(icon="chevron-down")
			.track-info.flex-col(v-if="!compact")
				.track-info.flex-row.justify.name-field-holder(:style="{ '--color': aggregatedTrack.color || '#e0e0e0' }")
					.flex-1
						.name-field.full-height(v-if="$scopedSlots['track-name']")
							slot(name="track-name", :aggregatedTrack="aggregatedTrack" :track="track", :trackName="trackName")
						.name-field.full-height(v-else, :title="aggregatedTrack.name") {{aggregatedTrack.name}}
					.track-actions.flex-row.align-center
						.flex-row.space.wrap
							.button.no-space.flex-row.center.align-center.compact-icon(:title="compact ? $tCaption('Expand') : $tCaption('Collapse')", @click="toggleCompact", :class="[!compact ? 'rotated' : '']")
								fas(icon="chevron-down")
				.track-actions.flex-row.justify.space
					.left-actions.flex-row.space-small.wrap
						template(v-if="isAudio")
							.button.flex-row.center.align-center(:title="$tCaption('Solo')", :class="{ 'is-solo': isSolo }", @click="v => $emit('solo', aggregatedTrack)") S
							.button.flex-row.center.align-center(:title="$tCaption('Mute')", :class="{ 'is-muted': isMuted }", @click="$emit('mute', aggregatedTrack)") M
							slot(name="actions-left", :track="track", :aggregatedTrack="aggregatedTrack")
					.right-actions.flex-row.space-small.wrap
						slot(name="actions-right", :track="track", :aggregatedTrack="aggregatedTrack")
						.button.flex-row.center.align-center(:title="$tCaption('Delete track')", @click="onTrackDelete")
							fas(icon="trash")
				.flex-row.align-center(v-if="isAudio")
					AudioTrackerSliderButton(handleSize="20%", :min="0", :max="1", v-model="aggregatedTrack.volume", :step="0.01", :round="2", :isLogarithmic="true")
					.panner.flex-row.align-center
						.font-mini.grey L
						AudioTrackerRoundButton(:min="-1", :max="1", :step="0.05", :width="30", :scaleDegrees="[0,180]", :value="aggregatedTrack.panner", :round="2", :showValue="false", @change="onPanChange")
						.font-mini.grey R
				AudioTrackerVUMeter(v-if="isAudio", :isPlaying="tracker.isPlaying", :filters="getFilters()", :track="track", orientation="horizontal", :tracker="tracker", :aggregatedTrack="aggregatedTrack", :compact="true")
				.flex-row.align-center.justify.full-height.post-effects(v-if="isAudio && !track.__isSubTrack")
					.left.flex-row.space-small
						slot(name="post-effects-left", :track="track", :aggregatedTrack="aggregatedTrack")
					.font-small.upper.grey.flex-row.space.align-center
						.applied-effects(v-if="aggregatedTrack.postEffects.plugins.length") {{aggregatedTrack.postEffects.plugins.length}}
						span {{$auth.hasProAudio() ? $tCaption('Plugins') : $tCaption('Effects bank')}}
					.right.flex-row.space-small
						slot(name="post-effects-right", :track="track", :aggregatedTrack="aggregatedTrack")
						.button.flex-row.center.align-center(:title="$tCaption('Add plugins')", @click="showPostEffects(true)", v-if="$auth.hasProAudio()")
							fas(icon="list")
			slot
		AudioTrackerPostEffectsPopup(:visible.sync="postEffectsVisible", :postEffects="aggregatedTrack.postEffects", :tracker="tracker", :audioContext="tracker.audioContext",
			@hiding="v => { $emit('preview-plugins', false); postEffectsVisible = false; }")
			template(slot="actions-left")
				Loader(v-if="isPreviewing === 1", text="")
				DxButton(v-if="aggregatedTrack.postEffects.plugins.length && isPreviewing !== 1", :text="isPreviewing ? $tCaption('Stop', '@actions') : $tCaption('Preview')", type="normal", :icon="isPreviewing ? 'square' : 'fas fa-play'", @click="onPreview")
		WAPIPluginsManager(ref="wapiPluginsManager", :plugins="aggregatedTrack.wapiPlugins", :tracker="tracker", @open="plugin => tracker.showWAPIPluginInstance(aggregatedTrack, plugin.id, plugin.instance)")
		Popup(v-if="normalizePopup", :popupVisible.sync="normalizePopup", classes="tracker-dark", :width="300", :height="270", :closeOnOutsideClick="true", :title="$tCaption('Normalize')")
			.flex-col.space-medium
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Normalization value')}}
					.flex-row.space-medium.align-center 
						DxNumberBox(:value.sync="aggregatedTrack.normalize.value", stylingMode="filled", format="# dB", :showSpinButtons="true", :disabled="!aggregatedTrack.normalize.enabled")
						DxCheckBox(:text="$tCaption('Enabled')", :value.sync="aggregatedTrack.normalize.enabled")
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Method')}}
					DxSelectBox(:data-source="normalizeMethods", :value="aggregatedTrack.normalize.method || 'peak'", @item-click="e => normalizeMethodChange(e.itemData.id)", 
						displayExpr="text", valueExpr="id", stylingMode="filled", :disabled="!aggregatedTrack.normalize.enabled")
</template>


<script>
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import { DxSlider } from 'devextreme-vue/slider';
	import DxButton from 'devextreme-vue/button';
	import audioTrackerEffectsMixin from './audioTrackerEffects';
	import AudioTrackerVUMeter from './AudioTrackerVUMeter.vue';
	import resizeObserver from 'resize-observer';
	import AudioTrackerRoundButton from './AudioTrackerRoundButton.vue';
	import AudioTrackInfoPanelPostEffects from './AudioTrackInfoPanelPostEffects.vue';
	import AudioTrackerSliderButton from './AudioTrackerSliderButton.vue';
	import Popup from 'app-core/Popup.vue';
	import WAPIPluginsManager from './plugins/WAPIPluginsManager.vue';
	import Loader from 'app-core/Loader.vue';
	import DxNumberBox from 'devextreme-vue/number-box'
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxSelectBox from 'devextreme-vue/select-box'
	import AudioTrackerPostEffectsPopup from './AudioTrackerPostEffectsPopup.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackInfoPanel',
		name: 'audio-track-info',
		components: {
			DxSlider, AudioTrackerVUMeter, AudioTrackerRoundButton, AudioTrackerSliderButton, DxSelectBox,
			AudioTrackInfoPanelPostEffects, Popup, DxButton, WAPIPluginsManager, Loader, DxNumberBox, DxCheckBox,
			AudioTrackerPostEffectsPopup },
		mixins: [audioTrackerEffectsMixin],
		props: {
			track: VueTypes.any.def({}),
			aggregatedTrack: VueTypes.any.def({}),
			effects: VueTypes.any.def(null),
			source: VueTypes.any.def(null),
			audioContext: VueTypes.any.def(null),
			tracker: VueTypes.any.def(null)
		},
		data() {
			return {
				trackName: null,
				compact: this.track.__isSubTrack,
				currentTrackId: this.track.id,
				postEffectsVisible: false,
				isPreviewing: false,
				normalizePopup: false,
				normalizeMethods: [
					{ id: 'peak', text: this.$tCaption('Peak') },
					{ id: 'lufs', text: this.$tCaption('Loudness (LUFS)') }
				]
			};
		},
		computed: {
			isSolo() {
				return this.track?.__isSolo != null ? this.track?.__isSolo : this.aggregatedTrack.__isSolo;
			},
			isMuted() {
				return this.aggregatedTrack.muted || this.aggregatedTrack.__internallyMuted;
			},
			isAudio() {
				return this.aggregatedTrack?.__type !== 'video';
			}
		},
		watch: {
			'track.volume'(v) {
				if (this.currentTrackId !== this.track?.id) return;
				if (this.effects) {
					this.effects.gain.gain.value = v;
					this.$emit('volume-changed', this.track);
				}
			},
			'track.insertion': {
				handler() {
					this.trackName = this.getTrackName();
				},
				deep: true
			},
			'track': {
				handler() {
					this.trackName = this.getTrackName();
					setImmediate(() => {
						this.currentTrackId = this.track?.id;
					})
				},
				deep: true
			},
			'track.__isSrcLoaded'() {
				this.trackName = this.getTrackName();
			},
			'track.effects'() {
				if (this.currentTrackId !== this.track?.id) return;
				this.restoreTrackEffects('track.effects', this.track, this.effects);
			},
			'track.sourceTrack.muted'(v) {
				if (this.currentTrackId !== this.track?.id) return;
				this.track.muted = v;
			},
			'compact'() {
				this.emitSizeChange();
			},
			aggregatedTrack: {
				handler(v) {
					this.$restoreTrackEffects('aggregatedTrack handler');
					if (v?.__addDataToUndoHistory)
						v?.__addDataToUndoHistory();
				},
				deep: true
			}
		},
		mounted() {
			this.trackName = this.getTrackName();
			this.$restoreTrackEffects = _.debounce(this.restoreTrackEffects, 20, {
				'leading': false,
				'trailing': true,
				'maxWait': 200
			});
			this.$restoreTrackEffects('mounted');
			this.$unobserve = resizeObserver.observe(this, this.$el, this.onSizeChanged);
			this.emitSizeChange();
		},
		destroyed() {
			if (this.$unobserve)
				this.$unobserve();
			delete this.$unobserve;
			delete this.$restoreTrackEffects;
		},
		methods: {
			normalizeMethodChange(v) {
				this.$set(this.aggregatedTrack.normalize, 'method', v);
				this.$set(this.aggregatedTrack.normalize, 'value', v === 'lufs' ? -13 : -3);
			},
			showWAPIPluginsManager() {
				this.$refs.wapiPluginsManager?.show();
			},
			showNormalizePopup() {
				this.normalizePopup = false;
				setImmediate(() => this.normalizePopup = true);
			},
			emitSizeChange() {
				this.$emit('size-changed', this.track);
			},
			onPreview() {
				if (this.isPreviewing) {
					this.$emit('preview-plugins', false);
					this.isPreviewing = 0;
				} else {
					this.isPreviewing = 1;
					this.$emit('preview-plugins', { 
						aggregatedTrack: this.aggregatedTrack, 
						track: this.track,
						loaded: () => this.isPreviewing = 2, 
						ended: () => this.isPreviewing = 0
					});
				}
			},
			toggleCompact() {
				this.compact = !this.compact;
				setImmediate(() => {
					this.emitSizeChange();
				});
			},
			restoreTrackEffects(log) {
				if (__DEBUG__)
					console.debug('Restore track effects', log);
				if (this.aggregatedTrack && this.tracker.tracksEffects[this.aggregatedTrack.trackNumber])
					this.tracker.restoreTrackEffects(this.aggregatedTrack, this.tracker.tracksEffects[this.aggregatedTrack.trackNumber]?.filters);
			},
			onPanChange(v) {
				this.aggregatedTrack.panner = v;
			},
			getFilters() {
				return this.track?.clipMuted ? null : this.tracker?.trackSourcesData[this.track?.id]?.effects?.filters;
			},
			getTrackName() {
				return typeof(this.track.name) === 'function' ? this.track.name(this.track) : this.track.name;
			},
			onSizeChanged() {
				this.emitSizeChange();
			},
			showPostEffects(v) {
				this.tracker.focusedAggregatedTrack = this.aggregatedTrack;
				this.postEffectsVisible = false;
				if (v) {
					setImmediate(() => {
						this.postEffectsVisible = true;
					})
				} else {
					this.$emit('preview-plugins', false);
				}
			},
			onTrackDelete() {
				if (this.track.__isSubTrack) {
					this.$emit('delete-tracks', this.tracker?.tracks?.filter(f => f.__subTrackGroup === this.track.__subTrackGroup));
				} else
					this.$emit('delete-aggregated-track', this.aggregatedTrack.trackNumber);
			}
		}
	};
</script>
<style lang='scss'>
	.audio-track-info {
		@import "main/themes/generated/variables.base.scss";

		.panner {
			margin-right: 4px;
		}

		.compact-icon {
			transform: rotate(0deg);

			&.rotated {
				transform: rotate(-180deg);
			}
		}

		.name-field-holder {
			border-bottom: 2px solid var(--color);
		}

		.post-effects {
			padding: 2px;

			.applied-effects {
				padding: 2px 4px;
				background: #777;
				color: #fff;
				border-radius: 2px;
			}
		}
	}
</style>
